export const colors = {
    primary: '#FFCF02',
    secondary: '#333247',
    tertiary: '#2BF2CE',
    quaternary: '#FD7B72',
    primaryGradient:
        'linear-gradient(180deg, #31384B 0%, #36273D 100%), #333333',
    secondaryGradient: 'linear-gradient(-90deg, #8FD2EC 1.01%, #FFFFFF 97.6%)',
};
